<div class="d-flex align-items-center justify-content-center analytics-group">
    <canvas id="shipment-bar-chart"></canvas>
</div> 